export const createUserRequests = (client) => ({
    getCurrentUser: async (params) => {
        const { data } = await client.api.request({
            type: "user",
            method: "GET",
            url: "/users/me",
            params: params,
        });
        return { data };
    },
    createUser: async (payload) => {
        const { data, meta } = await client.api.create("users", payload);
        return { data, meta };
    },
    updateUser: async (payload) => {
        const { data } = await client.api.update("users", payload);
        return { data };
    },
    listUsers: async (params) => {
        const { data, meta, links } = await client.api.get("users", {
            params: params,
        });
        return { data, meta, links };
    },
    findUser: async (params) => {
        const { data } = await client.api.get(`users/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    impersonateUser: async (payload) => {
        const res = await client.api.request({
            type: "user",
            method: "POST",
            url: "/users/impersonate",
            body: payload,
        });
        return res;
    },
});
//# sourceMappingURL=index.js.map